import React, { FC } from 'react';
import { generatePath, useHistory } from 'react-router';
import styled from 'styled-components';
import { format } from 'date-fns';
import { ROUTES } from '../../../constants/routes';
import { Cell, HeaderCell, Left, NoMatching, RowsWrapper, Underlined, Wrapper } from './TableStyles';

type Props = {
    ActivitiesRows: any[];
};
const ActivitiesTable: FC<Props> = ({ ActivitiesRows }) => {
  const history = useHistory();
  const onClick = row => {
    const path = generatePath(ROUTES.PERMIT, {
      projectId: row.projectId,
      permitId: row.permitId,
    });
    history.push(path);
  };

  return (
    <Wrapper>
      <Row>
        <HeaderCell>
          <Left>Project - Permit</Left>
        </HeaderCell>
        <HeaderCell>
          <Left>Activity Title</Left>
        </HeaderCell>
        <HeaderCell>
          <Left>Follow Up</Left>
        </HeaderCell>
      </Row>
      <RowsWrapper>
        {ActivitiesRows.length === 0 && <NoMatching>No matching records found</NoMatching>}
        {ActivitiesRows.length > 0 &&
          ActivitiesRows.map((activity, index) => {
            return (
              <Row key={index}>
                <Cell>
                  <Left>
                    <Underlined onClick={e => onClick(activity)}>{`${activity.projectName} - ${activity.permitName}`}</Underlined>
                  </Left>
                </Cell>
                <Cell>
                  <Left>{activity.activityTitleName}</Left>
                </Cell>
                <Cell>
                  <Left>{format(new Date(activity.followUp), 'MM/dd/yyyy')}</Left>
                </Cell>
              </Row>
            );
          })}
      </RowsWrapper>
    </Wrapper>
  );
};

export default ActivitiesTable;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 264px repeat(2, 1fr);
  border-bottom: 1px solid var(--border);
  border-right: 1px solid var(--border);
  border-left: 1px solid var(--border);
  border-radius: 6px;
`;
